module.exports = __webpack_public_path__ + "img/search-by-bib.feffda43.jpg";